import { forwardRef, Ref, useImperativeHandle, useRef } from "react";

import { IsoLocale, Nullable } from "@simplyk/common";
import { FieldValues, Path } from "react-hook-form";

import { OutlinedTextFieldWysiwyg } from "../OutlinedTextFieldWysiwyg/OutlinedTextFieldWysiwyg";
import {
  FroalaConfig,
  OutlinedTextFieldWysiwygProps,
  OutlinedTextFieldWysiwygRef,
} from "../OutlinedTextFieldWysiwyg/type";

interface OutlinedMailFieldWysiwygProps<T extends FieldValues> extends Omit<OutlinedTextFieldWysiwygProps<T>, "id"> {
  zIndex?: number;
  isoLocale?: IsoLocale;
  height?: string | number;
  heightMax?: string | number;
  subjectName: Path<T>;
  subjectRef: React.MutableRefObject<Nullable<HTMLInputElement>>;
  attachmentKeyName?: Path<T>;
}

function OutlinedMailFieldWysiwygInternal<T extends FieldValues>(
  props: OutlinedMailFieldWysiwygProps<T>,
  ref: Ref<OutlinedTextFieldWysiwygRef>
) {
  const innerRef = useRef<OutlinedTextFieldWysiwygRef>(null);

  useImperativeHandle(
    ref,
    () => ({
      openTemplateMenu: () => {
        innerRef.current?.openTemplateMenu();
      },
    }),
    []
  );

  return (
    <OutlinedTextFieldWysiwyg<T>
      keyName={`mailFieldWysiwyg-${props.name}`}
      config={FroalaConfig.Email}
      id={props.name}
      {...props}
      ref={innerRef}
    />
  );
}

export const OutlinedMailFieldWysiwyg = forwardRef(OutlinedMailFieldWysiwygInternal) as <T extends FieldValues>(
  props: OutlinedMailFieldWysiwygProps<T> & { ref?: React.Ref<OutlinedTextFieldWysiwygRef> }
) => ReturnType<typeof OutlinedMailFieldWysiwygInternal>;
